const pages = ["/", "/collections/all", "/collections/new", "/cart", "/account"]
const path = location.pathname
const isPath = pages.includes(path)

// bottom navigation自体を非表示にするページ
const hidePages = ["/pages/lp", "/pages/cbd-tea"]

if (hidePages.includes(path)) {
    document.querySelector(".footer-menu").style.display = "none"
}

// パスが配列に含まれている場合はis-activeを付与
if (isPath) {
    const menuLinks = document.querySelectorAll(".menu-list li a");
    menuLinks.forEach((link) => {
        if (link.getAttribute("href") === path) {
            link.classList.add("is-active");
        }
    });
}

